/**
 * Content Module Component
 * Handles slide-in animations and interactivity for the content module section
 */

(function() {
  class ContentModule extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Check if animation is enabled via data attribute
      const textElement = this.querySelector('[data-animation-type="text"]');
      
      if (!textElement) return;

      // Trigger animation on page load or when element becomes visible
      if (this.isAnimationEnabled(textElement)) {
        this.observeElementVisibility(textElement);
      }
    }

    isAnimationEnabled(element) {
      // Check if the element has the animation class
      return element.classList.contains('content-module-animated');
    }

    observeElementVisibility(element) {
      // Use Intersection Observer to trigger animation when element enters viewport
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animation class when element enters viewport
            entry.target.style.animation = null; // Reset to allow animation to trigger
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1, // Trigger when 10% of element is visible
        rootMargin: '50px' // Start animation slightly before element is fully visible
      });

      observer.observe(element);
    }

    disconnectedCallback() {
      // Cleanup if needed
    }
  }

  // Register the custom element
  customElements.define('content-module', ContentModule);
})();
